exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-0760481b]{padding:0 10px 50px}.ipt[data-v-0760481b]{width:100%;padding:10px 20px;border-radius:8px;box-sizing:border-box;border:1px solid #d6d5d5;margin:10px 0 0}.type_list[data-v-0760481b]{width:100%;margin:10px 0 0 5px;text-align:center;display:flex;flex-wrap:wrap}.type_list li[data-v-0760481b]{position:relative;background:hsla(0,0%,95%,.5);border-radius:5px;margin:10px 0;width:30.6%;box-sizing:border-box;height:150px}.type_list li p[data-v-0760481b]{position:absolute;bottom:20px;left:0;vertical-align:bottom;width:100%}.type_list li.separate[data-v-0760481b]{margin-left:10px;margin-right:10px}.type_list img[data-v-0760481b]{position:absolute;top:50%;left:50%;margin-top:-25px;margin-left:-25px;width:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0760481b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/search.vue
// module id = 78
// module chunks = 0